import React, { useEffect, useState } from 'react'
import './breadcrumb.scss';

import siteUrl from '../../../utils/siteUrl';
import { utilGtm } from '../../../utils/utilGtm';

const Breadcrumb = ({ page = 'Home' }) => {

    const [elements, setElements] = useState([]);

    /*const camelize = (str) => {
        console.log('str '+str)
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            console.log(word)
            return index === 0 ? word.toUpperCase() : word.toUpperCase();
        }).replace(/\s+/g, '').replace(/-/g, ' ');
    }*/

    const camelize = (str) => {
        return str.split('-').map((word) => {
            return word[0].toUpperCase() + word.substring(1)
        }).join(" ")
    }

    useEffect(() => {
        var path = decodeURI(window.location.pathname);
        var elements = path.split('/')
        elements.shift()
        if (elements[elements.length - 1] === '') elements.pop()
        setElements(elements);
    }, []);


    return (

        <div className="a-breadcrumb-container">
            <div className="a-breadcrumb-element">
                <a className={`a-link a-link-breadcrumb gtm${page}ClicBreadcrumbsInicio`} href={siteUrl + '/'}>Inicio</a>
            </div>

            {elements.slice(0, 3).map((element, index) => {
                var fullPath = ''
                elements.map((elementPath, indexPath) => indexPath <= index ? fullPath += elementPath + '/' : '')

                if (index < elements.length - 1) {
                    return (
                        <div key={index} className="a-breadcrumb-element">
                            <span className="a-breadcrumb-separator"><i className="o-icon fal fa-arrow-right"></i></span>
                            <a
                                className={"a-link a-link-breadcrumb " + utilGtm(`gtm${page}ClicBreadcrumbs`, element)}
                                href={siteUrl + '/' + fullPath}
                            > {camelize(element)} </a>
                        </div>

                    )

                } else {
                    return (
                        <div key={index} className="a-breadcrumb-element">
                            <span className="a-breadcrumb-separator"><i className="o-icon fal fa-arrow-right"></i></span>
                            <span className="a-current-site">{camelize(element)}</span>
                        </div>

                    )
                }
            })}
        </div>
    )
}

export default Breadcrumb;
